import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import { config } from '../../../CommonUtils/CommonURLS'
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtils/CommonAxios'
import Swal from 'sweetalert2'
import allowNumbersOnly, { handlePaste } from '../../../CommonUtils/CommonValidations'
import { useSelector } from 'react-redux'
import { failureAlert } from '../../../CommonUtils/SweetAlerts'
import { UseGetStatus } from '../../../CommonUtils/Commonstatus'
import { AC_YEAR_OLD } from '../../../CommonUtils/contextVariables'
function AdditionalSectionsforExistingCourses() {

    const coursesFlags = useSelector((state) => state?.commonMastersReducer?.coursesFlags);
    const [getData, setData] = useState([])
    const hasFetchedData = useRef(false);
    const formik = useFormik({
        initialValues: {
            isAdditionalSections: '',
            data: [{
                slno: '',
                addlCourseRequestedSections21: ''
            }]
        },
        onSubmit: (val) => {
            if (
                val?.isAdditionalSections === "null" ||
                val?.isAdditionalSections === undefined ||
                val?.isAdditionalSections === ""
            ) {
                Swal.fire({
                    title: "Required Fields",
                    text: 'Please select "Is college applying for any additional sections to the existing courses?"',
                    icon: 'warning',
                    backdrop: false,
                    confirmButtonText: 'OK'
                });
                return;
            }
            if (val.isAdditionalSections == "true") {
                const incompleteIndex = val.data.findIndex(
                    item => item.addlCourseRequestedSections21 === null ||
                        item.addlCourseRequestedSections21 === undefined ||
                        item.addlCourseRequestedSections21 === ''
                );
                if (incompleteIndex !== -1) {
                    Swal.fire({
                        title: "Required Fields",
                        text: `At Row No  ${incompleteIndex + 1}   Please fill in the Additional Number of Sections.`,
                        icon: "warning",
                        backdrop: false,
                    });
                    return;
                }
            }
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {

                    let payload = val?.data.map(row => ({
                        ...row,
                        isAdditionalSections: val?.isAdditionalSections,
                        addlCourseRequestedSections21: row?.addlCourseRequestedSections21
                    }));
                    let url = config.url.API_URL + `saveAdditionalSections`
                    CommonAxiosPost(url, payload).then((res) => {
                        if (res?.data?.scode === '01') {
                            Swal.fire({
                                text: res?.data?.sdesc,
                                icon: "success",
                                backdrop: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false

                            }).then((refresh) => {
                                if (refresh.isConfirmed) {
                                    GetData();
                                    UseGetStatus();
                                }
                            })
                        }
                        else {
                            failureAlert('Failed to Submit')
                        }
                    })
                }
            })
        }
    })

    function GetData() {
        let url = config.url.API_URL + `getAdditionalSections`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                let data = res?.data?.getAdditionalSections
                setData(data);
                let updatedData = data?.length > 0 ? data?.map((ac) => ({
                    addlCourseRequestedSections21: ac?.addl_course_requested_sections_21 ?? '',
                    slno: ac?.slno
                })) : [{
                    addlCourseRequestedSections21: '',
                    isAdditionalSections: ''
                }]
                formik?.setFieldValue('data', updatedData)
            }
        })
    }
    const ClearValues = () => {
        formik?.setFieldValue('data', [
            {
                addlCourseRequestedSections21: ''
            }
        ]);
    };
    useEffect(() => {
        formik?.setFieldValue('isAdditionalSections', coursesFlags?.additional_intake_existing_courses_flag?.toString());
        if (!hasFetchedData?.current) {
            GetData()
            hasFetchedData.current = true
        }
    }, [coursesFlags])

    const ValidateNoOfSection = (value, approv_no_of_sections) => {

        // Check for missing input
        if (value === null || value === undefined || value === '') {
            return 'required';
        }

        // Explicitly check if value is 0
        if (parseInt(value) === 0) {
            return '0 is not a valid value';
        }

        // Check if value exceeds approved number of sections
        if (parseInt(value) > approv_no_of_sections) {
            return `Value must be less than or equal to ${approv_no_of_sections}`;
        }

        return undefined;
    };



    return (
        <>
            <FormikProvider value={formik}>
                <Form onChange={formik?.handleChange} onSubmit={formik?.handleSubmit} className='affl-form'>
                    <h5>2. College Application for Additional Sections for Existing Courses</h5>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className='form-control'>
                        <label htmlFor="isAdditionalSections" style={{ marginRight: '10px', fontWeight: 'bold', color: 'red' }} >
                            Is college Applying for Any Additional Sections to the Existing courses :
                        </label>
                        <div style={{ marginBottom: '10px' }}>
                            <Field as='select' name='isAdditionalSections' className='form-control mt-2' style={{ width: 'auto' }}
                                onChange={(e) => {
                                    if (e?.target?.value === "false") { ClearValues(); }
                                }} >
                                <option value=''>--SELECT--</option>
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                            </Field>
                            <ErrorMessage name='isAdditionalSections' className='text-error' component='div' />
                        </div>
                    </div>
                    {/* {getData.length > 0 ? (<> */}

                    {formik?.values?.isAdditionalSections === 'true' && getData.length > 0 && (
                        <>
                            <div className="table-responsive mt-3">
                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                    <thead>
                                        <tr>
                                            <th>Sno</th>
                                            <th>Academic Program Type</th>
                                            <th>Course /Program</th>
                                            <th>Branch /Combination</th>
                                            <th>Medium</th>
                                            <th>Intake Approved for {AC_YEAR_OLD}</th>
                                            <th>Approved No. of Sections</th>
                                            <th>Course Duration</th>
                                            <th>Additional Number of Sections being requested<br /> (other than that are approved)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getData?.map((ec, i) => (
                                            <tr key={ec.slno}>
                                                <td>{i + 1}</td>
                                                <td className='text-left'>{ec?.course_group_desc}</td>
                                                <td className='text-left'>{ec?.course_cat_name}</td>
                                                <td className='text-left'>{ec?.course_name}</td>
                                                <td>{ec?.name}</td>
                                                <td>{ec?.final_sanction_intake}</td>
                                                <td>{ec?.approv_no_of_sections}</td>
                                                <td>{ec?.duration}</td>
                                                <td>
                                                    <Field type='text' name={`data[${i}].addlCourseRequestedSections21`} className='form-control-sm' maxLength='2'
                                                        // validate={(value) => ValidateNoOfSection(value, ec?.approv_no_of_sections)}

                                                        onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)} />
                                                    <ErrorMessage name={`data[${i}].addlCourseRequestedSections21`} className='text-error' component='div' />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}

                    {getData.length > 0 || formik?.values?.isAdditionalSections === 'false' ? (<>
                        <button type='submit' className='btn btn-success btn-sm float-end mt-3'>Submit</button><pre /><pre /><pre />
                        {/* </>)} */}
                    </>) : ((<center className='text-danger h5 pt-5'>***** No Data Found *****</center>))}

                </Form>
            </FormikProvider>
        </>
    )
}
export default AdditionalSectionsforExistingCourses
